import Vue from 'vue'
import PremiumDialog from '../components/core/PremiumDialog.vue'
import { getString } from '../lang/Strings'

let premiumAlertInstance = null

function createPremiumAlert() {
  if (!premiumAlertInstance) {
    const PremiumAlertClass = Vue.extend(PremiumDialog)
    premiumAlertInstance = new PremiumAlertClass()
    premiumAlertInstance.$mount()
    document.body.appendChild(premiumAlertInstance.$el)
  }
  return premiumAlertInstance
}

const PremiumAlertPlugin = {
  install(Vue) {
    const defaultOptions = {
        icon: '👑',
        modalTitle: getString('premium_conteudo_bloqueado_titulo'),
        msg: getString('funcionalidade_exclusiva_premium')
    }

    Vue.prototype.$premiumAlert = {
      show(options = {}) {
        const instance = createPremiumAlert()
        const mergedOptions = { ...defaultOptions, ...options }
        
        Object.keys(mergedOptions).forEach(key => {
          if (key in (instance.$props || {})) {
            instance[key] = mergedOptions[key]
          }
        })
        
        instance.show()
        return instance
      },
      
      hide() {
        const instance = createPremiumAlert()
        instance.hide()
      }
    }
  }
}

export default PremiumAlertPlugin